import { map } from 'lodash4';

export class NumsToDayNamesService {
  constructor(private DayOfTheWeekEnum: any) {}

  numsToDayNames(dayNums: number[], name: string) {
    return map(dayNums, (dayNum: number) => {
      if (dayNum > 7 || dayNum < 1) {
        name = 'longname';
        dayNum = 8;
      }
      return this.DayOfTheWeekEnum.get(dayNum).value[name];
    });
  }
}

angular.module('capability-ng-course-schedule').service('ngNumsToDayNamesService', NumsToDayNamesService);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/services/nums_to_day_names.ts